//@flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';

import warningIcon from '../../../../../assets/img/warningIcon.png';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';

import CustomModal from '../../../../../elements/CustomModal/CustomModal';

type Props = {|
  handleFeaturedCoupon?: () => void,
  openModal?: boolean,
  handleCloseModal?: () => void,
|};

const useStyles = makeStyles(theme => ({
  mediumText: {
    textAlign: 'center',
    fontWeight: 700,
    fontSize: '36px',
    lineHeight: '40px',
    color: 'white',
    paddingRight: '8px',
    display: 'flex',
    margin: 'auto',
    alignItems: 'center',
  },
  titleModal: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '24px',
    color: '#313135',
    textAlign: 'center',
  },
  bodyModal: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#55556D',
    textAlign: 'center',
  },
}));

export default function AlertFeaturedModal(props: Props) {
  const {handleFeaturedCoupon, handleCloseModal, openModal} = props;
  const classes = useStyles();

  return (
    <CustomModal open={openModal} handleCloseModal={handleCloseModal}>
      <div style={{maxWidth: '300px', padding: '24px', textAlign: 'center'}}>
        <div className={classes.imageModal}>
          <img src={warningIcon} alt="Warn icon" />
        </div>
        <br />
        <div className={classes.titleModal}>
          Sólo puedes destacar un cupón a la vez.
        </div>
        <div className={classes.bodyModal}>
          Se reemplazará el cupón existente por este.
        </div>
        <br />
        <div>
          {handleFeaturedCoupon && (
            <CustomButton variant="contained" onClick={handleFeaturedCoupon}>
              Reemplazar cupón
            </CustomButton>
          )}
        </div>
        <br />
        <div>
          <CustomButton
            variant="contained"
            color="default"
            onClick={handleCloseModal}
          >
            Cerrar
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
}

AlertFeaturedModal.propTypes = {
  handleFeaturedCoupon: PropTypes.func,
  openModal: PropTypes.bool,
  handleCloseModal: PropTypes.func,
};
